import { postData } from "../../utils/FormPost";

export const submit = (history, isFormWillBeRedirect, event, self, url, notHide) => {
  const data = new FormData(event.target);
  postData(history, isFormWillBeRedirect, url, data, !notHide && document.querySelector('.form__receivedMsg'));
  self.setState({showFormSuccess: true});
  if (!notHide && !isFormWillBeRedirect) {
    setTimeout(() => {
      self.setState({showFormSuccess: false});
      self.setState({isValidated: false});
      document.querySelector('.form__receivedMsg').textContent = ''
    }, 5000)
  }
}


// WEBPACK FOOTER //
// ./src/components/Form/Submit.js